// src/redux/layout/reducer.ts
// --------------------------------------------------------------------------

/* ───── Importaciones de tipos y constantes ────────────────────────────── */
import {
  LayoutActionTypes,
  LayoutStateTypes,
} from './constants';                         // tipos y enum del slice

/* ───── Importaciones de constantes globales de layout ─────────────────── */
import {
  TwoColumnTheme,
  LayoutMode,
  LayoutTypes,
  LayoutColor,
  LayoutWidth,
  MenuPositions,
  SideBarTheme,
  SideBarTypes,
  TopbarTheme,
} from '../../constants/layout';

/* ───── Tipos de acciones que llegan al reducer ────────────────────────── */
import { LayoutActionType } from './actions';

/* ───── Utilidades ─────────────────────────────────────────────────────── */
import { getLayoutConfigs } from '../../utils';

/* ───── Estado inicial, ya tipado ──────────────────────────────────────── */
const INIT_STATE: LayoutStateTypes = {
  twoColumnTheme: TwoColumnTheme.TWOCOLUMN_LIGHT,
  layoutMode: LayoutMode.LAYOUT_DEFAULT,
  sidenavUser: false,
  layoutType: LayoutTypes.LAYOUT_VERTICAL,
  layoutColor: LayoutColor.LAYOUT_COLOR_LIGHT,
  layoutWidth: LayoutWidth.LAYOUT_WIDTH_FLUID,
  menuPosition: MenuPositions.MENU_POSITION_FIXED,
  leftSideBarTheme: SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT,
  leftSideBarType: SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT,
  showTwoToneIcons: false,
  showSidebarUserInfo: false,
  topbarTheme: TopbarTheme.TOPBAR_THEME_DARK,
  isOpenRightSideBar: false,
};

/* ───── Reducer principal ──────────────────────────────────────────────── */
const Layout = (
  state: LayoutStateTypes = INIT_STATE,
  action: LayoutActionType<string | boolean | null>
): LayoutStateTypes => {
 switch (action.type) {
  /*--------------------------------------------------*/
  case LayoutActionTypes.CHANGE_TWOCOLUMN_THEME:
    return {
      ...state,
      twoColumnTheme: action.payload as TwoColumnTheme,
    };

  case LayoutActionTypes.CHANGE_LAYOUT:
    return {
      ...state,
      layoutType: action.payload as LayoutTypes,
    };

  case LayoutActionTypes.CHANGE_LAYOUT_MODE:
    return {
      ...state,
      layoutMode: action.payload as LayoutMode,
    };

  case LayoutActionTypes.CHANGE_LAYOUT_COLOR:
    return {
      ...state,
      layoutColor: action.payload as LayoutColor,
    };

  case LayoutActionTypes.CHANGE_LAYOUT_WIDTH: {
    const layoutConfig = getLayoutConfigs(action.payload as LayoutWidth);
    return {
      ...state,
      layoutWidth: action.payload as LayoutWidth,
      ...layoutConfig,
    };
  }

  case LayoutActionTypes.CHANGE_MENU_POSITIONS:
    return {
      ...state,
      menuPosition: action.payload as MenuPositions,
    };

  case LayoutActionTypes.CHANGE_SIDEBAR_THEME:
    return {
      ...state,
      leftSideBarTheme: action.payload as SideBarTheme,
    };

  case LayoutActionTypes.CHANGE_SIDEBAR_TYPE:
    return {
      ...state,
      leftSideBarType: action.payload as SideBarTypes,
    };

  case LayoutActionTypes.TOGGLE_SIDEBAR_USER_INFO:
    return {
      ...state,
      showSidebarUserInfo: action.payload as boolean,
    };

  case LayoutActionTypes.CHANGE_TOPBAR_THEME:
    return {
      ...state,
      topbarTheme: action.payload as TopbarTheme,
    };

  case LayoutActionTypes.TOGGLE_TWO_TONE_ICONS:
    return {
      ...state,
      showTwoToneIcons: action.payload as boolean,
    };

  /*--------------------------------------------------*/
  case LayoutActionTypes.SHOW_RIGHT_SIDEBAR:
    return { ...state, isOpenRightSideBar: true };

  case LayoutActionTypes.HIDE_RIGHT_SIDEBAR:
    return { ...state, isOpenRightSideBar: false };

  default:
    return state;
}

};

export default Layout;
